import React from 'react';
import { Link } from 'react-router-dom';
import { Zap } from 'lucide-react';
import { useTenant } from '../../contexts/TenantContext';

import { cn } from '../../lib/utils';

export const PublicFooter = () => {
  const { node, brand, activeBrandId } = useTenant();
  const brandName = brand.name;
  const theme = 'bauhaus';

  const s = {
    footer: 'bg-white dark:bg-black border-t-[8px] md:border-t-[12px] border-black dark:border-white text-black dark:text-white',
    logo: 'text-black dark:text-white font-black uppercase tracking-tighter text-2xl',
    heading: 'text-black dark:text-white font-black',
    text: 'text-black dark:text-white hover:text-[#0044FF] dark:hover:text-[#FFD600] font-bold',
    border: 'border-black dark:border-white border-t-[4px] md:border-t-[8px]'
  };

  return (
    <footer className={cn("py-12 px-4 border-t", s.footer)}>
      <div className="w-full grid grid-cols-1 md:grid-cols-4 gap-8 max-w-7xl mx-auto px-4 md:px-12">
        <div className="space-y-4">
          <div className={cn("text-xl font-display font-bold flex items-center gap-2", s.logo)}>
            {brand.logoUrl ? (
              <img src={brand.logoUrl} alt={brandName} className="h-6 w-6 object-contain bg-slate-900/5 dark:bg-white/90 p-0.5 rounded-sm" referrerPolicy="no-referrer" />
            ) : (
              <Zap className="fill-current" size={24} style={{ color: brand.primary }} />
            )}
            {brandName}
          </div>
          <p className={cn("text-sm leading-relaxed", s.text)}>
            The modern multi-chapter membership management software and club & association management platform.
          </p>
        </div>
        
        <div>
          <h4 className={cn("font-bold mb-6 uppercase text-[10px] tracking-widest font-mono", s.heading)}>Product</h4>
          <ul className="space-y-4 text-sm">
            <li><Link to="/features" onClick={() => window.scrollTo(0, 0)} className={cn("transition-colors", s.text)}>Features</Link></li>
            <li><Link to="/use-cases" onClick={() => window.scrollTo(0, 0)} className={cn("transition-colors", s.text)}>Use Cases</Link></li>
            <li><Link to="/plans" onClick={() => window.scrollTo(0, 0)} className={cn("transition-colors", s.text)}>Plans</Link></li>
            <li><Link to="/board-memo" onClick={() => window.scrollTo(0, 0)} className={cn("transition-colors", s.text)}>Board Pitch Memo</Link></li>
            <li><Link to="/tools" onClick={() => window.scrollTo(0, 0)} className={cn("transition-colors", s.text)}>Tools</Link></li>
            <li><Link to="/showcase" onClick={() => window.scrollTo(0, 0)} className={cn("transition-colors", s.text)}>Showcase</Link></li>
            <li><Link to="/compare" onClick={() => window.scrollTo(0, 0)} className={cn("transition-colors", s.text)}>Compare</Link></li>
            <li><Link to="/tools/orgle" onClick={() => window.scrollTo(0, 0)} className={cn("transition-colors flex items-center gap-1.5 opacity-75 hover:opacity-100", s.text)}><span>Orgle</span><span className="text-[9px] font-mono px-1 py-0.2 bg-[#FFD600] text-black font-black uppercase">Word Game</span></Link></li>
          </ul>
        </div>
        
        <div>
          <h4 className={cn("font-bold mb-6 uppercase text-[10px] tracking-widest font-mono", s.heading)}>Company</h4>
          <ul className="space-y-4 text-sm">
            <li><Link to="/about" onClick={() => window.scrollTo(0, 0)} className={cn("transition-colors", s.text)}>About Us</Link></li>
            <li><Link to="/mission" onClick={() => window.scrollTo(0, 0)} className={cn("transition-colors", s.text)}>Our Mission</Link></li>
            <li><Link to="/newsroom" onClick={() => window.scrollTo(0, 0)} className={cn("transition-colors", s.text)}>Newsroom</Link></li>
            <li><Link to="/contact" onClick={() => window.scrollTo(0, 0)} className={cn("transition-colors", s.text)}>Contact</Link></li>
          </ul>
        </div>
        
        <div>
          <h4 className={cn("font-bold mb-6 uppercase text-[10px] tracking-widest font-mono", s.heading)}>Legal</h4>
          <ul className="space-y-4 text-sm">
            <li><Link to="/privacy" onClick={() => window.scrollTo(0, 0)} className={cn("transition-colors", s.text)}>Privacy Policy</Link></li>
            <li><Link to="/terms" onClick={() => window.scrollTo(0, 0)} className={cn("transition-colors", s.text)}>Terms of Service</Link></li>
            <li><Link to="/cookies" onClick={() => window.scrollTo(0, 0)} className={cn("transition-colors", s.text)}>Cookie Policy</Link></li>
            <li><Link to="/security" onClick={() => window.scrollTo(0, 0)} className={cn("transition-colors", s.text)}>Security</Link></li>
            <li><Link to="/dpa" onClick={() => window.scrollTo(0, 0)} className={cn("transition-colors", s.text)}>DPA</Link></li>
            <li><Link to="/aup" onClick={() => window.scrollTo(0, 0)} className={cn("transition-colors", s.text)}>Acceptable Use</Link></li>
            <li><Link to="/dmca" onClick={() => window.scrollTo(0, 0)} className={cn("transition-colors", s.text)}>DMCA</Link></li>
          </ul>
        </div>
      </div>
      
      <div className={cn("w-full pt-8 mt-12 border-t flex flex-col md:flex-row justify-between items-center gap-4 max-w-7xl mx-auto px-4 md:px-12", s.border)}>
        <p className={cn("text-[10px] uppercase tracking-widest font-mono opacity-50", s.text)}>
          © 2026 {brandName} Inc. All rights reserved.
        </p>
        <div className="flex items-center gap-4">
          <span className="text-[10px] font-black uppercase tracking-widest opacity-60 border-l-4 border-[#0044FF] pl-3">Free to start · No credit card required</span>
        </div>
      </div>
    </footer>
  );
};
